export const UserRole = {
  Admin: 0,
  Editor: 1,
};

export const bannerText =
  "WE SHIP WORLDWIDE!";

/*
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = "menu-default";

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const defaultLocale = "en";
export const localeOptions = [
  { id: "en", name: "English - LTR", direction: "ltr" },
  { id: "es", name: "Español", direction: "ltr" },
  { id: "enrtl", name: "English - RTL", direction: "rtl" },
];

export const firebaseConfig = {
  apiKey: "AIzaSyCFmxdYr8K8qIgVXG9vADvOWUItqoUX628",
  authDomain: "paperganesh-website.firebaseapp.com",
  projectId: "paperganesh-website",
  storageBucket: "paperganesh-website.appspot.com",
  messagingSenderId: "530775727773",
  appId: "1:530775727773:web:bf16416026b3455ea53e74",
  measurementId: "G-ZPL0BVD2W7",
};
export const adminRoot = "/";
export const searchPath = `${adminRoot}/#`;

export const currentUser = {
  id: 1,
  title: "Sarah Kortney",
  img: "/assets/img/profiles/pilot.png",
  date: "Last seen today 15:24",
  role: UserRole.Admin,
};

export const themeColorStorageKey = "__theme_selected_color";
export const isMultiColorActive = false;
export const defaultColor = "light.orangecarrot";
export const isDarkSwitchActive = false;
export const defaultDirection = "ltr";
export const themeRadiusStorageKey = "__theme_radius";
export const isAuthGuardActive = true;
export const colors = [
  "bluenavy",
  "blueyale",
  "blueolympic",
  "greenmoss",
  "greenlime",
  "purplemonster",
  "orangecarrot",
  "redruby",
  "yellowgranola",
  "greysteel",
];

export const sizeRangeArray = [
  {
    minVal: 8,
    maxVal: 17,
    sortIndex: 1,
    src: "https://console.paperganesh.com/api/v1.0/file-store/62bed4c49d4eb0fd23acd9ce",
  },
  {
    minVal: 18,
    maxVal: 22,
    sortIndex: 2,
    src: "	https://console.paperganesh.com/api/v1.0/file-store/62c747f199345c49df1a475c",
  },
  {
    minVal: 23,
    maxVal: 25,
    sortIndex: 3,
    src: "	https://console.paperganesh.com/api/v1.0/file-store/62c889b699345c49df1bf4ce",
  },
  {
    minVal: 26,
    maxVal: 30,
    sortIndex: 4,
    src: "https://console.paperganesh.com/api/v1.0/file-store/62cf1a714e9dcbff8834bf52",
  },
  {
    minVal: 30,
    maxVal: 36,
    sortIndex: 5,
    src: "https://console.paperganesh.com/api/v1.0/file-store/62c7462799345c49df1a4718",
  },
];

export const datameters = [
  {
      name:"visits",
      count:150
  },
  {
      name:"orders",
      count:"1.5K"
  },
  {
      name:"wishlisted",
      count:200
  },
  {
      name:"delivered",
      count:"15K"
  },
]


/*=============================
BANNER
==============================*/
// export const BannerImages = [
//   {
//     id: "1",
//     mobile: "https://ppg-public.s3.ap-south-1.amazonaws.com/static/images/banner/desktop/Image1.png",
//     web: "https://ppg-public.s3.ap-south-1.amazonaws.com/static/images/banner/desktop/Image1.png",
//   },
//   {
//     id: "2",
//     mobile: "https://ppg-public.s3.ap-south-1.amazonaws.com/static/images/banner/desktop/Image2.png",
//     web: "https://ppg-public.s3.ap-south-1.amazonaws.com/static/images/banner/desktop/Image2.png",
//   },
//   {
//     id: "3",
//     mobile: "https://ppg-public.s3.ap-south-1.amazonaws.com/static/images/banner/desktop/Image3.png",
//     web: "https://ppg-public.s3.ap-south-1.amazonaws.com/static/images/banner/desktop/Image3.png",
//   },
//   {
//     id: "4",
//     mobile: "https://ppg-public.s3.ap-south-1.amazonaws.com/static/images/banner/desktop/Image4.png",
//     web: "https://ppg-public.s3.ap-south-1.amazonaws.com/static/images/banner/desktop/Image4.png",
//   },
// ];
export const BannerImages = [
  {
    id: "1",
    mobile: "https://ppg-public.s3.ap-south-1.amazonaws.com/static/images/banner/desktop/image5.png",
    web: "https://ppg-public.s3.ap-south-1.amazonaws.com/static/images/banner/desktop/image8.png",
  },
  {
    id: "2",
    mobile: "https://ppg-public.s3.ap-south-1.amazonaws.com/static/images/banner/desktop/image6.png",
    web: "https://ppg-public.s3.ap-south-1.amazonaws.com/static/images/banner/desktop/image9.png",
  },
  {
    id: "3",
    mobile: "https://ppg-public.s3.ap-south-1.amazonaws.com/static/images/banner/desktop/image7.png",
    web: "https://ppg-public.s3.ap-south-1.amazonaws.com/static/images/banner/desktop/image10.png",
  }
];
// export const BannerImages = [
//   {
//     id: "1",
//     mobile: "https://ppg-public.s3.ap-south-1.amazonaws.com/static/images/banner/desktop/image1.jpg",
//     web: "https://ppg-public.s3.ap-south-1.amazonaws.com/static/images/banner/desktop/image1.jpg",
//   },
//   {
//     id: "2",
//     mobile: "https://ppg-public.s3.ap-south-1.amazonaws.com/static/images/banner/desktop/image2.jpg",
//     web: "https://ppg-public.s3.ap-south-1.amazonaws.com/static/images/banner/desktop/image2.jpg",
//   },
//   {
//     id: "3",
//     mobile: "https://ppg-public.s3.ap-south-1.amazonaws.com/static/images/banner/desktop/image3.jpg",
//     web: "https://ppg-public.s3.ap-south-1.amazonaws.com/static/images/banner/desktop/image3.jpg",
//   },
//   {
//     id: "4",
//     mobile: "https://ppg-public.s3.ap-south-1.amazonaws.com/static/images/banner/desktop/image4.jpg",
//     web: "https://ppg-public.s3.ap-south-1.amazonaws.com/static/images/banner/desktop/image4.jpg",
//   },
// ];


